import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { datadogRum } from "@datadog/browser-rum";

export const useSessionReplay = (initialized: boolean) => {
  const location = useLocation();

  useEffect(() => {
    if (!initialized) return;

    if (location.pathname === "/consignado-privado") {
      datadogRum.startSessionReplayRecording();
    } else {
      datadogRum.stopSessionReplayRecording();
    }
  }, [location.pathname, initialized]);
};
